module.exports = __webpack_public_path__ + "static/img/p_14.daa7bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_14.png
// module id = 2Bdk
// module chunks = 9